import * as React from "react";
import Typography from "@mui/material/Typography";

/**
 * A React component that calculates the next month and current year for the Coming Next Month
 * section of the Video Intro Page.
 *
 * @param props - React props is not currently used.
 * @returns - The NextMonthYear React component in JSX.
 */
export default function NextMonthYear(props: any) {
  const currentDate = new Date();
  let currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  let nextMonth = currentMonth + 1;
  if (nextMonth > 11) {
    nextMonth = 0;
    currentYear++;
  }
  const nextMonthName = new Date(currentYear, nextMonth).toLocaleString(
    "default",
    {
      month: "long",
    }
  );
  const nextMonthYear = `${nextMonthName} ${currentYear}`;
  const nextMonthYearString = nextMonthYear.replace(/ /g, "\u00A0");
  return (
    <Typography variant="h2" sx={{ marginBottom: 10 }}>
      {"Coming Next Month: " + "July 2025"}
    </Typography>
  );
}
